Candidates to retrieve summaries for (1-100 per request).
